import { AlternativeButton } from '@/components/common/Gallery/styles';
import Icon from '@/units/Icon';
import { ArrowDirection, ArrowProps } from '@/components/common/Gallery/types';
import { FC } from 'react';

export const AlternativeArrow: FC<ArrowProps> = ({ className, style, onClick, direction }) => {
  return (
    <AlternativeButton
      className={className}
      style={{ ...style, marginBottom: '100px' }}
      onClick={onClick}
    >
      {direction === ArrowDirection.Left && (
        <Icon.ChevronLeft style={{ color: 'white', fontSize: '18px', left: '15px' }} />
      )}
      {direction === ArrowDirection.Right && (
        <Icon.ChevronRight style={{ color: 'white', fontSize: '18px', right: '15px' }} />
      )}
    </AlternativeButton>
  );
};
